import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import SidebarSolicitante from '../Components/Sidebar/Sidebar';
import api from '../apiClient';
import { useTiposChamado } from '../../hooks/useTiposChamado';
import { useStatusChamado } from '../../hooks/useStatusChamado';
import StatusBadge from '../Components/StatusBadge/StatusBadge';
import PageHeader from '../Components/PageHeader/PageHeader';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoTokenSolicitante from '../../FuncoesGerais/VerificarTokenSolicitante';
import '../theme/solicitante-theme.css';
import '../Home/home.css';
import './SatiFechada.css';

function ChamadoFechadoCard({ sati, tipoNome, statusList, onOpen }) {
    const data = sati.data ? new Date(sati.data) : null;
    const dataFmt = data && !Number.isNaN(data.getTime())
        ? data.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
        : '—';
    return (
        <article
            className="sol-card sol-card--interactive sol-chamado-card sol-chamado-card--fechado"
            role="button"
            tabIndex={0}
            onClick={() => onOpen(sati.id)}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && (e.preventDefault(), onOpen(sati.id))}
        >
            <div className="sol-chamado-card-top">
                <span className="sol-chamado-num">#{sati.id}</span>
                <StatusBadge statusVal={sati.status} statusList={statusList} fallback="Finalizado" />
            </div>
            <span className="sol-chamado-tipo">{tipoNome}</span>
            <p className="sol-chamado-desc">{sati.descricao || 'Sem descrição'}</p>
            <div className="sol-chamado-meta">
                <span title="Data"><i className="fas fa-calendar-alt" /> {dataFmt}</span>
                <span title="Atendente"><i className="fas fa-user-headset" /> {sati.atendente || '—'}</span>
            </div>
            <span className="sol-chamado-open"><i className="fas fa-arrow-right" /></span>
        </article>
    );
}

function SatiFechadaSolicitante() {
    const history = useHistory();
    const codUsu = localStorage.getItem('codUsu');
    const { getNome } = useTiposChamado();
    const { statusList } = useStatusChamado();

    const [data, setData] = useState([]);
    const [texto, setTexto] = useState('');
    const [loading, setLoading] = useState(true);

    const verificar = useCallback(async () => {
        const resultado = await verificandoApp('SOLICITANTE');
        if (!resultado) {
            history.push('/');
            return;
        }
        await verificandoTokenSolicitante(history);
    }, [history]);

    const fetchData = useCallback(async (termo) => {
        setLoading(true);
        const descr = (termo != null ? termo : texto) || '';
        const colab = String(codUsu || '');
        try {
            const response = await api.post('/api/conSatiConsulta', { descr, colab });
            const lista = (Array.isArray(response.data) ? response.data : []).map((row) => ({
                id: row.id,
                descricao: (row.descricao || '').substring(0, 140),
                data: row.data,
                atendente: row.nomeAtendente ?? row.atendente,
                tipo: row.tipo ?? row.SATTIP,
                status: row.SATSTASAI
            }));
            setData(lista);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setData([]);
        } finally {
            setLoading(false);
        }
    }, [texto, codUsu]);

    useEffect(() => {
        verificar();
        fetchData('');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmitBusca = (e) => {
        e.preventDefault();
        fetchData(texto);
    };

    return (
        <div className="app-layout">
            <SidebarSolicitante />
            <main className="main-content sol-page">
                <div className="sol-container">
                    <PageHeader
                        title="Histórico de chamados"
                        subtitle="Seus chamados concluídos e encerrados"
                        actions={(
                            <>
                                <form className="sol-search" onSubmit={onSubmitBusca}>
                                    <i className="fas fa-search" />
                                    <input
                                        className="sol-input"
                                        type="text"
                                        value={texto}
                                        onChange={(e) => setTexto(e.target.value)}
                                        placeholder="Buscar por descrição..."
                                        aria-label="Buscar no histórico"
                                    />
                                </form>
                                <button type="button" className="sol-btn sol-btn--icon" onClick={() => fetchData(texto)} title="Atualizar" aria-label="Atualizar">
                                    <i className="fas fa-sync-alt" />
                                </button>
                            </>
                        )}
                    />

                    {loading ? (
                        <div className="sol-grid">
                            {[0, 1, 2, 3, 4, 5].map((i) => (
                                <div key={i} className="sol-card sol-chamado-card">
                                    <div className="sol-chamado-card-top">
                                        <div className="sol-skeleton sol-skeleton--line" style={{ width: 56 }} />
                                        <div className="sol-skeleton sol-skeleton--pill" />
                                    </div>
                                    <div className="sol-skeleton sol-skeleton--text" style={{ width: '40%' }} />
                                    <div className="sol-skeleton sol-skeleton--text" style={{ width: '92%' }} />
                                    <div className="sol-skeleton sol-skeleton--text" style={{ width: '70%' }} />
                                </div>
                            ))}
                        </div>
                    ) : data.length === 0 ? (
                        <div className="sol-card sol-empty">
                            <div className="sol-empty-icon"><i className="fas fa-clock-rotate-left" /></div>
                            <h2 className="sol-empty-title">{texto ? 'Nenhum chamado encontrado' : 'Seu histórico está vazio'}</h2>
                            <p className="sol-empty-text">
                                {texto ? 'Tente outra busca ou limpe o filtro.' : 'Chamados concluídos ou cancelados aparecerão aqui.'}
                            </p>
                        </div>
                    ) : (
                        <div className="sol-grid sol-stagger">
                            {data.map((sati) => (
                                <ChamadoFechadoCard
                                    key={sati.id}
                                    sati={sati}
                                    tipoNome={getNome(sati.tipo)}
                                    statusList={statusList}
                                    onOpen={(id) => history.push('/Solicitante/historicoSatiFechada/' + id)}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
}

export default SatiFechadaSolicitante;
